
// NOTE: This allows us to propagate a change whenever one of
// the pieces of recoil state changes. In this case we're
// saving the result to local storage to preserve the state
// if the browser refreshes.
// Taken from: https://recoiljs.org/docs/guides/atom-effects/#local-storage-persistence
export const localStorageEffect = (key: string) => 
({setSelf, onSet}: {setSelf: any, onSet: any}) => {
  const savedValue = localStorage.getItem(key);
  if (savedValue && savedValue !== null) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    setSelf(JSON.parse(savedValue));
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  onSet((newValue: string, _: any, isReset: boolean) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isReset 
      ? localStorage.removeItem(key)
      : localStorage.setItem(key, JSON.stringify(newValue));
  });
};
